import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/dz.png';
const _withScopeId = n => (_pushScopeId("data-v-40023550"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 您当前的位置： ")], -1));
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'bread',
  props: {
    title: String
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const goback = () => {
      window.scrollTo(0, 0);
      router.push({
        path: '/'
      });
    };
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        separator: ">",
        class: "bread"
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_breadcrumb_item, {
          onClick: goback
        }, {
          default: _withCtx(() => [_createTextVNode(" 首页 > ")]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, {
          style: {
            "color": "blue"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.title), 1)]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});